<template>
<div id="main">
    <div class="panel-total-despesasviagem">
      <div class="d-flex justify-content-center pt-3 title-card-sales">
        TOTAL DESPESAS VIAGEM
      </div>
      <div class="sales-value">
        R$ {{calcularTotalDespesaViagemUsuario}}
      </div>
    </div>
  <Forms ref="frmSearch"
           title="PESQUISA DE REEMBOLSO VIAGEM"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :ShowFooterImbo="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClear"
           v-on:Search="$emit('onLoadFuncionario', dataFormSearch)"
          >
           <div>
              <div>
                <label class="label-search">Situação:</label>
                <select v-model="dataFormSearch.situacao" class="form-control">
                  <option :value="null">Selecione um status</option>
                  <option v-for="data in dataStatusDespesa" :key="data.value" :value="data.value">{{data.text}}</option>
                </select>
              </div>
              <div>
                <label class="label-search">Categoria:</label>
                 <select v-model="dataFormSearch.categoria" class="form-control">
                  <option :value="null">Selecione uma categoria </option>
                  <option v-for="data in dataEnumCategoria" :key="data.value" :value="data.value">{{data.text}}</option>
                </select>
              </div>
              <div>
                <label class="label-search">SubCategoria:</label>
                <select :disabled="getsubcategoriaData.length == 0" v-model="dataFormSearch.subcategoria"  class="form-control">
                  <option :value="null">Selecione uma sub categoria</option>
                  <option v-for="data in getsubcategoriaData" :key="data.value" :value="data.value">{{data.text}}</option>
                </select>
              </div>
           </div>
      </Forms>
</div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'

export default {
  name: 'Search',
  mixins: [ActionsForm],
  props: ['calcularTotalDespesaViagemUsuario'],
  data () {
    return {
      dataFormSearch: {
        categoria: null,
        subcategoria: null,
        situacao: null
      },
      dataStatusDespesa: [],
      dataEnumCategoria: [],
      dataSubCategoriaVeiculo: [],
      dataSubCategoria: []
    }
  },
  computed: {
    getsubcategoriaData: function () {
      if (this.dataFormSearch.categoria === null || this.dataFormSearch.categoria === undefined) return []
      if (parseInt(this.dataFormSearch.categoria) === 0) return this.dataSubCategoria
      return this.dataSubCategoriaVeiculo
    },
    getsubcategoriaDataDetails: function () {
      if (this.dataExpenseDetails.categoria === null || this.dataExpenseDetails.categoria === undefined) return []
      if (parseInt(this.dataExpenseDetails.categoria) === 0) return this.dataSubCategoria
      return this.dataSubCategoriaVeiculo
    }
  },
  mounted () {
    this.GetStatusDespesa()
    this.GetCategoria()
    this.GetEnumSubCategoriaVeiculo()
    this.GetSubCategoria()
  },
  methods: {
    onClear () {
      Object.keys(this.dataFormSearch).forEach((Element) => {
        this.dataFormSearch[Element] = null
      })
    },
    GetSubCategoria () {
      TravelExpenseRepository.GetSubCategoria()
        .then((Response) => {
          this.dataSubCategoria = Response.data
        })
        .catch((Error) => {
          console.error(Error)
        })
    },
    GetStatusDespesa () {
      TravelExpenseRepository.GetAllStatusDespesas()
        .then((Response) => {
          this.dataStatusDespesa = Response.data
        })
        .catch((Error) => {
          console.error(Error)
        })
    },
    GetCategoria () {
      TravelExpenseRepository.GetCategoria()
        .then((Response) => {
          this.dataEnumCategoria = Response.data
        })
        .catch((Error) => {
          console.error(Error)
        })
    },
    GetEnumSubCategoriaVeiculo () {
      TravelExpenseRepository.GetEnumSubCategoriaVeiculo()
        .then((Response) => {
          this.dataSubCategoriaVeiculo = Response.data
        })
        .catch((Error) => {
          console.error(Error)
        })
    }
  }

}
</script>

<style scoped>
#main{
    height: 100%;
}
  .label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
.panel-total-despesasviagem-head{
    height: 40%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center ;
    color: white;
    font-weight: bold;
    font-size: 20px;
    border-radius: 10px 10px 0px 0px;
    background: green;

  }
.panel-total-despesasviagem-body{
    height: 60%;
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 20px;
    color: black;
    align-items: center;
  }
.panel-total-despesasviagem{
    width: 100%;
    background: white;
    height: 20%;
    border-radius:10px;
    margin-bottom: 5%;
  }

</style>



// WEBPACK FOOTER //
// src/views/private/finance/accountability/components/travelExpenseTab/components/boardtrevelexpenseemployee/components/search/search.vue